import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=3dc96ea8&"
import script from "./DataGrid.vue?vue&type=script&lang=js&"
export * from "./DataGrid.vue?vue&type=script&lang=js&"
import style0 from "./DataGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports